import { RotationCallerIdSource } from '@Typings/global.types';

export interface CallerIdData {
  id: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  accountId: string;
  callerId: string;
  callerName: string | null;
  callerSid: string | null;
  callSid: string;
  status: string;
}

export interface ProviderCallerIdData extends CallerIdData {
  isRevereficationRequired: boolean;
}

export interface CallerIdRotationList {
  userId: string;
  provider: string;
}

export interface CallerIdList {
  userId?: string;
}

export interface CallerIdRotationData {
  id: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  accountId: string;
  callerId: string;
  callerName: string | null;
  callerSid: string | null;
  callSid: string;
  isEnabled: boolean;
  stirShaken: boolean;
  status: string;
  source: string;
  voiceProvider: VoiceProvider;
  supportStirShaken: boolean;
  isRevereficationRequired: boolean;
}

export interface ForwardingNumberData {
  id: string;
  createdAt: string;
  accountId: string;
  forwardingNumber: string;
}

export interface AreaCodeData {
  areaCode: string;
}

export interface AddNewNumberInputs {
  phone: string;
}

export interface ChangeRotationEnablingResponse {
  message: string;
}

export interface ChangeRotationEnablingRequest {
  id: string;
  userId?: string;
}

export interface AddForwardingNumberInputs {
  forwardingNumber: string;
}

export interface AvailableNumber {
  areaCode: string;
  limit: string;
  userId?: string;
  voiceProvider?: VoiceProvider;
}

export interface AvailableNumberResponse {
  phoneNumber: string;
}

export interface BuyPhoneNumberRequest {
  userId?: string;
  areaCode?: string;
  phoneAmount?: string;
  phoneArray?: string[];
  callerIdType?: CallerIdType;
  hasUserTpr?: boolean;
  stirShaken?: boolean;
}

export interface BuyPhoneNumberResponse {
  boughtPhones: number;
}

export interface VerifyCallerRequest {
  phone: string;
  friendlyName?: string;
  source?: string;
  provider?: string;
}

export interface VerifyCallerSubmitVerificationCodeRequest {
  phone: string;
  verificationCode: string;
  isTpr: boolean;
}

export interface VerifyCallerSubmitVerificationCodeResponse {
  data: {
    recordType: string;
    phoneNumber: string;
    verifiedAt: string;
    userId: string;
    organizationId: string;
  };
}

export interface DeleteCallerIdRequest {
  id: string;
  userId?: string;
}

export interface VerifyCallerResponse {
  pin: string;
  phone: string;
  identifier: string;
  message: string;
}

export interface StirShakenRequest {
  callerId: string;
  stirShaken: boolean;
  userId?: string;
}

export interface DeleteRotationCallerIdRequest {
  id: string;
  source: RotationCallerIdSource;
  userId?: string;
}

export interface AddForwardingNumberRequest {
  forwardingNumber: string;
}

export interface SendSMSForNumberSharingRequest {
  phone: string;
}

export interface SendSMSForNumberSharingResponse {
  phoneSharingId: string;
  message: string;
}

export interface NumberSharingValidationRequest {
  id: string;
  pin: string;
  voiceProvider?: string;
}

export interface CheckCallerIdRequest {
  phone: string;
}

export interface CheckCallerIdResponse {
  accountId: string;
  userName: string;
  isAccountActive: boolean;
  hasPowerDialer: boolean;
  callerIdToCheck: string;
  voiceProvider: VoiceProvider;
  pendingDeactivation: string;
  isTpr: boolean;
}

export interface CheckCallerIdFileResponse {
  checkResults: CheckCallerIdResponse[];
}

export interface CheckCallerIdFileRequest {
  file: File;
}

export interface NumberSharingValidationResponse {
  success: boolean;
  message: string;
}

export interface GetTprSettingsRequest {
  id: string;
  provider: string;
}

export interface GetTprSettingsResponse {
  availableTprAmount: number;
  usedTprAmount: number;
}

export interface CheckCallerIdInput {
  phone: string;
}

export enum VerificationStatus {
  INITIATED = 'initiated',
  VERIFIED = 'verified',
  FAILED = 'failed',
}

export enum CallerIdType {
  TPR = 'tpr',
  REGULAR_CALLER_ID = 'regular',
}

export enum VoiceProvider {
  AUTO = 'AUTO',
  TWILIO = 'TWILIO',
  VONAGE = 'VONAGE',
  TELNYX = 'TELNYX',
}

export enum VonageMode {
  OLD = 'OLD',
  NEW = 'NEW',
}

export enum GlobalSettingName {
  VOICE_PROVIDER_DIAL_IN_NUMBER = 'VOICE_PROVIDER_DIAL_IN_NUMBER',
}
